import React from 'react';

/**
 * THE newspaper/document glyph — Order Completion's delivery-paperwork marker
 * (2026-08-16). Design: docs/superpowers/specs/2026-08-16-order-completion.md,
 * owner ruling: *"newspaper glyph, picked from the icon set in use at build
 * time"*.
 *
 * Built the way `ui/PaperclipIcon.js` was extracted (2026-08-11): the size and
 * colour stay with the caller via `className`, no default, `strokeWidth={2}`
 * baked in so it reads as the same icon family at every call site. This is a
 * TWO-PATH glyph (a folded sheet plus two text-column rules), deliberately
 * NOT the paperclip's single stroke — `OrderDeliveryPaperworkMarker` exists
 * precisely so a plain attachment and a delivery-paperwork attachment read as
 * two different signals, and sharing a silhouette with the paperclip would
 * undercut that from the icon alone.
 *
 * ♿ Purely decorative by default (`aria-hidden="true"`) — the caller that
 * uses it as a SOLE carrier of meaning (`OrderDeliveryPaperworkMarker`) must
 * label its own wrapper, exactly the contract `PaperclipIcon` documents.
 */
function NewspaperIcon({ className = '', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 5.5A1.5 1.5 0 015.5 4H15a1.5 1.5 0 011.5 1.5V17a2 2 0 002 2H6a2 2 0 01-2-2V5.5z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M18.5 8H19a1.5 1.5 0 011.5 1.5V17a2 2 0 01-2 2" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M7 8h6M7 11h6M7 14h3" />
    </svg>
  );
}

export default NewspaperIcon;
